/**
 * @file claim模块路由配置
 */
// 货物类型
const GoodsType = () =>
  import(
    /* webpackChunkName: "claim-goods-type" */ '../views/claim/goods-type'
  );
// 货损情况
const AccidentDesc = () =>
  import(
    /* webpackChunkName: "claim-accident-desc" */ '../views/claim/accident-desc'
  );
// 选择银行
const SelectBank = () =>
  import(
    /* webpackChunkName: "claim-select-bank" */ '../views/claim/select-bank'
  );
// 理赔进度
const claimStatus = () =>
  import(
    /* webpackChunkName: "claim-status" */ '../views/claim/claim-status.vue'
  );
// 理赔详情
const claimDetail = () =>
  import(
    /* webpackChunkName: "claim-detail" */ '../views/claim/claim-detail.vue'
  );
// 补交资料
const claimSupply = () =>
  import(
    /* webpackChunkName: "claim-supply" */ '../views/claim/claim-supply.vue'
  );
// 选择订单
const SelectOrder = () =>
  import(
    /* webpackChunkName: "claim-select-order" */ '../views/claim/select-order/index.vue'
  );

// 理赔入口
const claimEntry = resolve =>
  import(
    /* webpackChunkName: "claim-entry" */ '../views/claim/claim-entry/index.vue'
  );
// 选择责任人
const SelectResponsible = () =>
  import(
    /* webpackChunkName: "claim-select-responsible" */ '../views/claim/select-responsible'
  );

export default [
  {
    name: 'goodsType',
    path: '/claims/goods-type',
    component: GoodsType,
    meta: { title: '货物类型' },
  },
  {
    name: 'accidentDesc',
    path: '/claims/accident-desc',
    component: AccidentDesc,
    meta: { title: '货损情况' },
  },
  {
    name: 'selectBank',
    path: '/claims/select-bank',
    component: SelectBank,
    meta: { title: '选择银行' },
  },
  {
    name: 'claimStatus',
    path: '/claims/claim-status',
    component: claimStatus,
    meta: { title: '保障金申请进度' },
  },
  {
    name: 'claimDetail',
    path: '/claims/claim-detail',
    component: claimDetail,
    meta: { title: '保障金申请详情' },
  },
  {
    name: 'claimSupply',
    path: '/claims/claim-supply',
    component: claimSupply,
    meta: { title: '补交资料', keepAlive: true },
  },
  {
    name: 'selectOrder',
    path: '/claims/select-order',
    component: SelectOrder,
    meta: { title: '选择订单' },
  },
  {
    name: 'claimEntry',
    path: '/claims/claim-entry',
    component: claimEntry,
    meta: { title: '申请保障金' },
  },
  {
    name: 'selectResponsible',
    path: '/claims/select-responsible',
    component: SelectResponsible,
    meta: { title: '选择责任人' },
  },

];
